import React, { PureComponent } from 'react'
import { Platform, AppState } from 'react-native'
import * as ScreenOrientation from 'expo-screen-orientation'

import { Provider } from 'react-redux'
import { ThemeProvider } from 'styled-components'

import Main from './navigators/authenticated'
import theme from './styles/theme'

import NavigationService from './services/navigation'
import HeartBeater from './services/heartbeater'
import { deviceNetworkConnectionUpdate, appHasBecomeActive } from './redux/device'
import NetInfo from './lib/netinfo'

class App extends PureComponent {
  constructor (props) {
    super(props)
    NavigationService.setStore(props.store)
    if (Platform.OS !== 'web') {
      ScreenOrientation.lockAsync(ScreenOrientation.OrientationLock.LANDSCAPE).then(() => {})
    }
    this.heartbeater = new HeartBeater(props.store)
  }

  componentDidMount () {
    AppState.addEventListener('change', this.handleAppStateChange)
    if (NetInfo) {
      this.unsubscribe = NetInfo.addEventListener(this.handleConnectivityChange)
    }
    this.heartbeater.start()
  }

  componentWillUnmount () {
    AppState.removeEventListener('change', this.handleAppStateChange)
    if (this.unsubscribe) {
      this.unsubscribe()
    }
  }

  handleAppStateChange = (nextAppState) => {
    if (nextAppState === 'active') {
      Promise.resolve(appHasBecomeActive(this.props.store))
      if (!this.heartbeater.working && this.state.initialised) {
        this.heartbeater.start()
      }
    }
  }

  handleConnectivityChange = (state) => {
    this.props.store.dispatch(deviceNetworkConnectionUpdate(state.isConnected))
  }

  render () {
    return (
      <ThemeProvider theme={theme}>
        <Provider store={this.props.store}>
          <Main ref={navigatorRef => {
            NavigationService.setAuthNavigator(navigatorRef)
          }}
          />
        </Provider>
      </ThemeProvider>
    )
  }
}

export default App
